module.exports = __webpack_public_path__ + "static/customize-phone-3@2x-31297b4624a9479a4025bb18a7e830ef.png";